import { createSelector } from 'reselect';
import { flow, property, isNil, get } from 'lodash';

const bookIdSelector = createSelector(property('contacts.makeAppointment'), (immutableData) =>
  get(immutableData.get('data'), 'bookId'),
);
export const appointmentIdSlice = createSelector(
  [property('router.params.id'), bookIdSelector],
  (queryValue, storeValue) => queryValue || storeValue,
);
export const appointmentsSlice = property('contacts.appointments');
export const isCanceledSlice = flow(appointmentsSlice, (appointments) =>
  appointments.get('cancelSuccess'),
);
export const cancelErrorSlice = flow(appointmentsSlice, (appointments) =>
  appointments.get('cancelError'),
);

export const cancelLoadingSlice = flow(appointmentsSlice, (appointments) =>
  appointments.get('cancelLoading'),
);

export const bookingSelector = createSelector(
  [appointmentIdSlice, appointmentsSlice],
  (bookId, appointments) => appointments.getIn(['data', bookId]),
);

export const isAppointmentsLoadingSelector = createSelector([appointmentsSlice], (appointments) =>
  appointments.get('loading'),
);
export const isAppointmentsPresentedSelector = createSelector(
  [appointmentsSlice],
  (appointments) => !isNil(appointments.get('data')),
);
